import styled from 'styled-components';

const AddConfigParametersWrapper = styled.div`
  .add-primary-tabs {
    .input-label {
      margin: 0;
      font-family: regular_semibold;
    }
    .custom-form-group {
      width: calc(33.33% - 10px);
      margin: 10px 20px;
    }
    .ant-input {
      font-family: regular_medium;
    }
    .error-message {
      color: red;
      transition: all .2s ease-out;
      opacity: 0;
      padding: 0;
    }
    .show-error-message {
      opacity: 1;
      padding: 5px 0 0 0;
    }
  }
  .parameters-wrapper {
    align-items: center;
    .add-parameter {
      width: calc(50% - 40px);
      margin: 20px;
      .input-label {
        margin: 0 0 10px 0;
        font-family: regular_semibold;
      }
      .add-parameter-btn {
        margin-left: 10px;
      }
    }
    .ant-input {
      font-family: regular_medium;
    }
    .error-message {
      color: red;
      transition: all .2s ease-out;
      opacity: 0;
      padding: 0;
    }
    .show-error-message {
      opacity: 1;
      padding: 5px 0 0 0;
    }
  }
  .add-report-template {
    width: 100%;
    .input-label, .select-label {
      margin: 0 0 10px 0;
      font-family: regular_semibold;
    }
    .ant-input {
      font-family: regular_medium;
    }
    .form-input-group {
      min-width: 25%;
      width: 25%;
      margin: 20px;
    }
    .form-select-group {
      width: 75%;
      max-width: 75%;
      margin: 20px;
    }
    .add-template-btn {
      margin: 50px 20px 0 0;
    } 
    .error-message {
      color: red;
      transition: all .2s ease-out;
      opacity: 0;
      padding: 0;
    }
    .show-error-message {
      opacity: 1;
      padding: 5px 0 0 0;
    }
  }
  .selected-reports-list {
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    padding: 20px;
    .ant-tag {
      align-self: flex-start;
      white-space:normal !important;
      height:auto !important;
      margin: 5px 0;
      .report-title {
        display: inline-block;
        max-width: 100%;
      }
    }
  }
`;

export default AddConfigParametersWrapper;


// WEBPACK FOOTER //
// ./src/components/Miscellaneous/AddConfigParemeters/AddConfigParameters.style.js